module.exports = __webpack_public_path__ + "static/media/139-st-lucia.ec7ec6ed.svg";